import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsArticlesRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-articles',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles',
	exact: true,
};
